import loadingGif from '../../assets/img/loading.gif';
import React, { useState, useEffect, Fragment } from "react";
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import axios from 'axios';
import AuthService from '../../Auth/AuthService.js';
import { settings } from './../../Helpers/Settings.js';
import { ToastContainer, toast } from "react-toastify";
import DatePicker from "react-datepicker";
import moment from 'moment';
import PageTitle from "../../Components/PageTitle.js";
import Swal from 'sweetalert2';
import { decodeToken, isExpired } from "react-jwt";
import GridKarekod from "./GridKarekod.js";
import 'react-tooltip/dist/react-tooltip.css';
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";

import Excel from 'exceljs';
import { saveAs } from 'file-saver';

const Karekod = () => {
    const [showKarekodGrubu, setShowKarekodGrubu] = useState(false);
    const handleCloseKarekodGrubu = () => setShowKarekodGrubu(false);
    const handleShowKarekodGrubu = () => setShowKarekodGrubu(true);

    const [showImport, setShowImport] = useState(false);
    const handleCloseImport = () => setShowImport(false);
    const handleShowImport = () => setShowImport(true);

    const [loading, setLoading] = useState(false);

    const [isTokenExpired, setIsTokenExpired] = useState(false);
    const [yetkiGor, setYetkiGor] = useState(null);
    const [yetkiEkle, setYetkiEkle] = useState(false);
    const [yetkiDegistir, setYetkiDegistir] = useState(false);
    const [yetkiSil, setYetkiSil] = useState(false);

    const [sort, setSort] = useState("");

    const [karekodGrubuKriter, setKarekodGrubuKriter] = useState("");
    const [urunGrubuIdKriter, setUrunGrubuIdKriter] = useState(0);
    const [urunOlcusuIdKriter, setUrunOlcusuIdKriter] = useState(0);
    const [gtinKriter, setGtinKriter] = useState("");
    const [refNoKriter, setRefNoKriter] = useState("");
    const [miktarKriter, setMiktarKriter] = useState("");
    const [karekodSayisiKriter, setKarekodSayisiKriter] = useState("");
    const [karekodUretilenSayisiKriter, setKarekodUretilenSayisiKriter] = useState("");
    const [olusturulmaZamaniKriter, setOlusturulmaZamaniKriter] = useState([null, null]);
    const [olusturulmaZamani1Kriter, olusturulmaZamani2Kriter] = olusturulmaZamaniKriter;

    const [karekodGrubuIdData, setKarekodGrubuIdData] = useState(0);
    const [karekodGrubuData, setKarekodGrubuData] = useState("");
    const [urunGrubuUrunOlcusuIdData, setUrunGrubuUrunOlcusuIdData] = useState(0);

    const [importVeriData, setImportVeriData] = useState("");
    const [importTipi, setImportTipi] = useState("");

    const [dataUrunGrubuUrunOlcusu, setDataUrunGrubuUrunOlcusu] = useState([]);
    const [dataUrunGrubu, setDataUrunGrubu] = useState([]);
    const [dataUrunOlcusu, setDataUrunOlcusu] = useState([]);
    const [data, setData] = useState([]);

    const [pageNo, setPageNo] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [rowCount, setRowCount] = useState(0);

    const [checkAll, setCheckAll] = useState(false);

    const days = ['Pz', 'Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct']
    const months = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık']

    const datePickerLocale = {
      localize: {
        day: n => days[n],
        month: n => months[n]
      },
      formatLong: {
        date: () => 'dd.MM.yyyy'
      }
    }
    
    const workbook = new Excel.Workbook();

    const tokenYenile = async () => {
        if (isExpired(localStorage.getItem('ATGroupToken')) === true) {
            setIsTokenExpired(true);

            setShowKarekodGrubu(false);

            return false;
        } else {
            const mail = decodeToken(localStorage.getItem('ATGroupToken'))["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
            await AuthService.login(mail, localStorage.getItem('ATGroupToken'));
            return true;
        }
    }

    const handleCheckAll = () => {
        setCheckAll(!checkAll);

        const temp = data;

        temp.forEach((item) => {
            item.checked = !checkAll;
        });

        setData(temp);
    }

    const handleCheck = (index, checked) => {
        const temp = [...data];
        data[index].checked = checked;
        setData(temp);
    };

    const handleOlusturulmaZamaniKriterChange = (e) => {
        if (tokenYenile() === false) {
            return;
        }
        setPageNo(1);
        setOlusturulmaZamaniKriter(e);
    };

    const handleSortClick = async (e) => {
        if (tokenYenile() === false) {
            return;
        }

        let temp = sort;

        const name = e.target.name;

        if (temp.startsWith(name)) {
            if (temp === name) {
                temp = name + " DESC";
            } else {
                temp = "";
            }            
        } else {
            temp = name;
        }

        setPageNo(1);
        setSort(temp);
    };

    useEffect(() => {
        getAcilisData();
    }, []);

    useEffect(() => {
        if (yetkiGor === true) {
            getData();
        }
    }, [pageNo, pageSize, sort]);

    function createDateAsUTC(date) {
        try {
            return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
        } catch (error) {
            return null;
        }
    }

    const Sorgula = async (e) => {
        if (tokenYenile() === false) {
            return;
        }

        if (pageNo !== 1) {
            await setPageNo(1);
        } else {
            await getData();
        }
    }

    const handlePageSize = async (e) => {
        if (tokenYenile() === false) {
            return;
        }
        await setPageNo(1);
        await setPageSize(e);
    }

    const handlePageNo = async (e) => {
        if (tokenYenile() === false) {
            return;
        }
        await setPageNo(e);
    }

    const NavIlk = async () => {
        if (tokenYenile() === false) {
            return;
        }
        await setPageNo(1);
    }

    const NavGeri = async () => {
        if ((pageNo - 1) >= 1) {
            if (tokenYenile() === false) {
                return;
            }
            await setPageNo(pageNo - 1);
        }
    }

    const NavIleri = async () => {
        if ((Number(pageNo) + 1) <= lastPage) {
            if (tokenYenile() === false) {
                return;
            }
            await setPageNo(Number(pageNo) + 1);
        }
    }

    const NavSon = async () => {
        if (tokenYenile() === false) {
            return;
        }
        await setPageNo(lastPage);
    }

    const getAcilisData = async () => {
        if (tokenYenile() === false) {
            return;
        }

        //const apiurl = process.env.REACT_APP_API_URL;

        let tempYetkiGor = await AuthService.getYetkiKontrolByYetki("Genel İşlemler - Karekod İşlemleri - Gör");

        setYetkiGor(tempYetkiGor);

        if (tempYetkiGor === true) {
            setYetkiEkle(await AuthService.getYetkiKontrolByYetki("Genel İşlemler - Karekod İşlemleri - Ekle"));
            setYetkiDegistir(await AuthService.getYetkiKontrolByYetki("Genel İşlemler - Karekod İşlemleri - Değiştir"));
            setYetkiSil(await AuthService.getYetkiKontrolByYetki("Genel İşlemler - Karekod İşlemleri - Sil"));

            setDataUrunGrubu((await axios.get(settings.ApiUrl + "Lookup/GetLookupBasic/UrunGrubu", { headers: AuthService.getHeaders() })).data.value);
            setDataUrunOlcusu((await axios.get(settings.ApiUrl + "Lookup/GetLookupBasic/UrunOlcusu", { headers: AuthService.getHeaders() })).data.value);
            setDataUrunGrubuUrunOlcusu((await axios.get(settings.ApiUrl + "Lookup/GetUrunGrubuUrunOlcusu", { headers: AuthService.getHeaders() })).data.value);

            await getData();
        }
    }

    const getData = async () => {
        const kriter = JSON.stringify({
            "karekodGrubu": karekodGrubuKriter,
            "urunGrubuId": urunGrubuIdKriter,
            "urunOlcusuId": urunOlcusuIdKriter,
            "gtin": gtinKriter,
            "refNo": refNoKriter,
            "miktar": miktarKriter === "" ? -1 : miktarKriter,
            "karekodSayisi": karekodSayisiKriter === "" ? -1 : karekodSayisiKriter,
            "karekodUretilenSayisi": karekodUretilenSayisiKriter === "" ? -1 : karekodUretilenSayisiKriter,
            "olusturulmaZamani1": olusturulmaZamani1Kriter === null ? "" : moment(createDateAsUTC(olusturulmaZamani1Kriter)).format('DD.MM.YYYY'),
            "olusturulmaZamani2": olusturulmaZamani2Kriter === null ? "" : moment(createDateAsUTC(olusturulmaZamani2Kriter)).format('DD.MM.YYYY'),
            "sort": sort,
            "pageNo": pageNo,
            "pageSize": pageSize
        });

        try {
            setLoading(true);

            const res = await axios.post(settings.ApiUrl + 'Karekod/GetKarekodGrubuList', kriter, { headers: AuthService.getHeaders() });

            setRowCount(res.data.rowCount);
            setLastPage(Math.ceil(res.data.rowCount / pageSize));
            setData(res.data.value);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    const handleExpandedKarekodGrubu = (index, expanded) => {
        const temp = [...data];
        temp[index].expanded = expanded;
        setData(temp);
    };

    const EkleKarekodGrubu = async () => {
        if (tokenYenile() === false) {
            return;
        }

        try {
            setLoading(true);

            setKarekodGrubuIdData(0);
            setKarekodGrubuData("");
            setUrunGrubuUrunOlcusuIdData(0);

            handleShowKarekodGrubu();
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    const DegistirKarekodGrubu = async (id) => {
        if (tokenYenile() === false) {
            return;
        }

        try {
            setLoading(true);

            const res = await axios.get(settings.ApiUrl + 'Karekod/GetKarekodGrubu/' + id, { headers: AuthService.getHeaders() });

            //const temp = data.filter(item => item.id === id)[0];

            setKarekodGrubuIdData(res.data.value.id);
            setKarekodGrubuData(res.data.value.karekodGrubu);
            setUrunGrubuUrunOlcusuIdData(res.data.value.urunGrubuUrunOlcusuId);

            handleShowKarekodGrubu();
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    const KaydetKarekodGrubu = async () => {
        if (tokenYenile() === false) {
            return;
        }

        if (karekodGrubuData === "" || urunGrubuUrunOlcusuIdData === 0) {
            Swal.fire({ title: "Hata", text: "Lütfen zorunlu alanları giriniz", icon: "error" });
        } else {
            try {
                setLoading(true);

                const data = JSON.stringify({
                    "id": karekodGrubuIdData,
                    "urunGrubuUrunOlcusuId": urunGrubuUrunOlcusuIdData,
                    "karekodGrubu": karekodGrubuData,
                    "karekodList": []
                });

                const result = await axios.post(settings.ApiUrl + 'Karekod/InsertOrUpdateKarekodGrubu/', data, { headers: AuthService.getHeaders() });

                if (result) {
                    if (result.data.success === true) {
                        await getData();
                        toast.success("Kaydedildi");
                        handleCloseKarekodGrubu();
                    } else {
                        toast.error("Hata oluştu: " + result.data.message);
                    }
                }
            } catch (error) {
                toast.error("Hata oluştu:" + error);
            } finally {
                setLoading(false);
            }
        }
    }
    
    const SilKarekodGrubu = async (id) => {
        if (tokenYenile() === false) {
            return;
        }

        Swal.fire({
            title: "Uyarı",
            text: "Kayıt silinecek, emin misiniz?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sil",
            cancelButtonText: "Vazgeç"
        }).then(async (resultSwal) => {
            if (resultSwal.isConfirmed) {
                try {
                    setLoading(true);

                    const resultGet = await axios.get(settings.ApiUrl + 'Karekod/GetKarekodGrubu/' + id, { headers: AuthService.getHeaders() });

                    if (resultGet && resultGet.data) {
                        const resultDelete = await axios.post(settings.ApiUrl + 'Karekod/DeleteKarekodGrubu/', [resultGet.data.value], { headers: AuthService.getHeaders() });

                        if (resultDelete) {
                            if (resultDelete.data.success === true) {
                                getData();
                                toast.success("Silindi");
                            } else {
                                toast.error(resultDelete.data.message);        
                            }
                        }
                    }
                } catch (error) {
                    toast.error(error);
                } finally {
                    setLoading(false);
                }
            }
        });
    }
    
    const YenileKarekodGrubu = async (id, index) => {
        try {
            setLoading(true);

            const result = await axios.get(settings.ApiUrl + 'Karekod/GetKarekodGrubu/' + id, { headers: AuthService.getHeaders() });

            if (result && result.data) {

                const temp = [...data];
                data[index].karekodSayisi = result.data.value.karekodSayisi;
                data[index].karekodUretilenSayisi = result.data.value.karekodUretilenSayisi;
                setData(temp);
            }
        } catch (error) {
            toast.error(error);
        } finally {
            setLoading(false);
        }
    }

    const ExportMatbaa = async (id, gizliSekmelerAcik) => {
        if (tokenYenile() === false) {
            return;
        }

        let temp = "";

        if (id === 0) {
            data.forEach(element => {
                if (element.checked === true) {
                    temp = temp + element.id + "_";
                }
            });

            if (temp === "") {
                Swal.fire({ title: "Hata", text: "En az bir satırı işaretleyiniz", icon: "error" });
                return;
            }

            temp = temp.substring(0, temp.length - 1);
        } else {
            temp = id;
        }

        const sheets = [];

        try {
            setLoading(true);

            const columns = gizliSekmelerAcik === 1 ?
                [
                    { header: 'ADET', key: 'sira' },
                    { header: 'REF', key: 'refNo' },
                    { header: 'Size / Grö𝛽e', key: 'urunOlcusu' },
                    { header: 'STERILE', key: 'sterilNo' },
                    { header: 'EXP', key: 'expireDate' },
                    { header: 'QR CODE', key: 'karekodUretilen' },
                    { header: 'GTIN', key: 'gtin' },
                    { header: '', key: 'sabit1' },
                    { header: 'USE by', key: 'useBy' },
                    { header: '', key: 'sabit2' },
                    { header: 'LOT', key: 'lot' },
                    { header: '', key: 'sabit3' },
                    { header: 'SN', key: 'seriNo' }
                ]
                :
                [
                    { header: 'ADET', key: 'sira' },
                    { header: 'REF', key: 'refNo' },
                    { header: 'Size / Grö𝛽e', key: 'urunOlcusu' },
                    { header: 'STERILE', key: 'sterilNo' },
                    { header: 'EXP', key: 'expireDate' },
                    { header: 'QR CODE', key: 'karekodUretilen' },
                    { header: 'GTIN', key: 'gtin' },
                    { header: 'USE by', key: 'useBy' },
                    { header: 'LOT', key: 'lot' },
                    { header: 'SN', key: 'seriNo' }
                ];

            const res = await axios.get(settings.ApiUrl + 'Karekod/GetMatbaaOrKutuList/' + temp + "/1", { headers: AuthService.getHeaders() });

            console.log(res);

            // Sheetler için ürün ölçülerini gruplandır 

            res.data.value.forEach(item => {
                const temp = sheets.filter(sheet => sheet.id === item.urunOlcusuId);

                if (temp.length === 0){
                    const newUrunOlcusu = {
                        id: item.urunOlcusuId,
                        name: item.urunOlcusu
                    };

                    sheets.push(newUrunOlcusu);
                }
            });

            // Excel

            sheets.forEach(sheet => {
                const data = res.data.value.filter(item => item.urunOlcusuId === sheet.id);

                const worksheet = workbook.addWorksheet(sheet.name);

                worksheet.columns = columns;
    
                worksheet.getRow(1).font = { bold: true };
    
                worksheet.columns.forEach(column => {
                    column.width = column.header.length + 5;
                    column.alignment = { horizontal: 'center' };
                });
    
                data.forEach(singleData => {
                    worksheet.addRow(singleData);
                });
    
                worksheet.eachRow({ includeEmpty: false }, row => {
                    const currentCell = row._cells;
    
                    currentCell.forEach(singleCell => {
                        const cellAddress = singleCell._address;
    
                        worksheet.getCell(cellAddress).border = {
                            top: { style: 'thin' },
                            left: { style: 'thin' },
                            bottom: { style: 'thin' },
                            right: { style: 'thin' }
                        };
                    });
                });
            });

            const buf = await workbook.xlsx.writeBuffer();

            saveAs(new Blob([buf]), 'Matbaa.xlsx');
        } catch (error) {
            console.log(error);
        } finally {
            sheets.forEach(sheet => {
                workbook.removeWorksheet(sheet.name);
            });

            setLoading(false);
        }
    }

    const ExportKutu = async (id) => {
        if (tokenYenile() === false) {
            return;
        }

        let temp = "";

        if (id === 0) {
            data.forEach(element => {
                if (element.checked === true) {
                    temp = temp + element.id + "_";
                }
            });

            if (temp === "") {
                Swal.fire({ title: "Hata", text: "En az bir satırı işaretleyiniz", icon: "error" });
                return;
            }

            temp = temp.substring(0, temp.length - 1);
        } else {
            temp = id;
        }

        const sheets = [];

        try {
            setLoading(true);

            const columns = [
                { header: 'REF', key: 'refNo' },
                { header: 'Size / Grö𝛽e', key: 'urunOlcusu' },
                { header: 'STERILE R', key: 'sterilNo' },
                { header: 'LOT', key: 'lot' },
                { header: 'EA', key: 'miktar' }
            ];

            const res = await axios.get(settings.ApiUrl + 'Karekod/GetMatbaaOrKutuList/' + temp + "/2", { headers: AuthService.getHeaders() });

            // Sheetler için kutuNoları gruplandır 

            res.data.value.forEach(item => {
                const temp = sheets.filter(sheet => sheet.id === item.kutuNo);

                if (temp.length === 0){
                    const newKutu = {
                        id: item.kutuNo
                    };

                    sheets.push(newKutu);
                }
            });

            // Excel

            sheets.forEach(sheet => {
                const data = res.data.value.filter(item => item.kutuNo === sheet.id);

                const worksheet = workbook.addWorksheet("Box" + sheet.id);

                worksheet.columns = columns;

                worksheet.getRow(1).font = { bold: true };

                worksheet.columns.forEach(column => {
                    column.width = column.header.length + 5;
                    column.alignment = { horizontal: 'center' };
                });

                data.forEach(singleData => {
                    worksheet.addRow(singleData);
                });

                const sum = [];
                sum[1] = "Toplam";
                sum[2] = "";
                sum[3] = "";
                sum[4] = "";
                sum[5] = { formula: `SUM(E2:E${data.length + 1})` };
                //sum[5] = "=SUM(E2:E" + (data.length + 1) + ")";

                worksheet.addRow(sum);

                worksheet.eachRow({ includeEmpty: false }, row => {
                    const currentCell = row._cells;

                    currentCell.forEach(singleCell => {
                        const cellAddress = singleCell._address;

                        worksheet.getCell(cellAddress).border = {
                            top: { style: 'thin' },
                            left: { style: 'thin' },
                            bottom: { style: 'thin' },
                            right: { style: 'thin' }
                        };
                    });
                });
            });

            const buf = await workbook.xlsx.writeBuffer();

            saveAs(new Blob([buf]), 'Box.xlsx');
        } catch (error) {
            console.log(error);
        } finally {
            sheets.forEach(sheet => {
                workbook.removeWorksheet("Box" + sheet.id);
            });

            setLoading(false);
        }
    }

    const Import = async (importTipi) => {
        if (tokenYenile() === false) {
            return;
        }

        setImportTipi(importTipi);
        setImportVeriData("");

        handleShowImport();
    }
    
    const KaydetImport = async () => {
        if (tokenYenile() === false) {
            return;
        }

        if (importVeriData === "") {
            Swal.fire({ title: "Hata", text: "Lütfen zorunlu alanları giriniz", icon: "error" });
        } else {
            try {
                setLoading(true);

                let apiLastName = importTipi === "KutuNo" ? "BulkUpdateKarekodUretilenKutuNo" : (importTipi === "SterilNo" ? "BulkUpdateKarekodSterilNo" : "");

                const result = await axios.post(settings.ApiUrl + "Karekod/" + apiLastName, importVeriData, { headers: AuthService.getHeaders() });

                if (result) {
                    if (result.data.success === true) {
                        await getData();

                        let sonuc = result.data.value;
                        let basarili = sonuc.split('/')[0];
                        let toplam = sonuc.split('/')[1];

                        if (basarili !== "0" && basarili === toplam) {
                            toast.success("Aktarım başarılı: " + sonuc);
                        } else if (basarili === "0" && toplam !== "0") {
                            toast.error("Aktarım başarısız: " + sonuc);
                        } else {
                            toast.info("Aktarım kısmen başarılı: " + sonuc);
                        }

                        handleCloseImport();
                    } else {
                        toast.error("Hata oluştu: " + result.data.message);
                    }
                }
            } catch (error) {
                toast.error("Hata oluştu:" + error);
            } finally {
                setLoading(false);
            }
        }
    }

    return (
        <Fragment>
            <Container>
                <ToastContainer position="bottom-right">
                </ToastContainer>
            </Container>
            
            <PageTitle></PageTitle>

            {
                isTokenExpired === true ?
                    <div className="alert alert-danger mb-1">
                        <button className="btn btn-link btn-sm" style={{color:"#58151c"}} onClick={() => AuthService.logout()}>Uzun süredir işlem yapmadığınız için oturumunuz sonlandırıldı. Lütfen tekrar giriş yapınız.</button>
                    </div>
                    :
                    yetkiGor !== null ?
                        yetkiGor === false ?
                            <div className="alert alert-danger">
                                Bu sayfaya erişim yetkiniz bulunmamaktadır
                            </div>
                            :
                            <div>
                                <div className="card info-card mb-3">
                                    {
                                        loading ?
                                            <div className="progressBackground">
                                                <div className="progressPopup">
                                                <img alt="Bekleyiniz..." src={loadingGif} />
                                                </div>
                                            </div>
                                            :
                                            ''
                                    }
                                    <div className="table-responsive" style={{border:"0px solid silver"}}>
                                        <table className="table table-bordered table-hover table-sm mb-0">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th style={{ textAlign: "center" }}><button name="KarekodGrubu" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>Proje No</button></th>
                                                    <th style={{ textAlign: "center" }}><button name="UrunGrubu" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>Ürün Grubu</button></th>
                                                    <th style={{ textAlign: "center" }}><button name="UrunOlcusu" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>Ürün Ölçüsü</button></th>
                                                    <th style={{ textAlign: "center" }}><button name="GTIN" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>GTIN</button></th>
                                                    <th style={{ textAlign: "center" }}><button name="RefNo" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>Ref No</button></th>
                                                    <th style={{ textAlign: "center" }}><button name="Miktar" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>Paket Miktarı</button></th>
                                                    <th style={{ textAlign: "center" }}><button name="KarekodSayisi" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>Karekod Sayısı</button></th>
                                                    <th style={{ textAlign: "center" }}><button name="KarekodUretilenSayisi" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>Üretilen Karekod Sayısı</button></th>
                                                    <th style={{ textAlign: "center" }}><button name="OlusturulmaZamani" className='btn btn-sm btn-link btn-link-sm' onClick={(e) => handleSortClick(e)}>Oluşturulma Zamanı</button></th>
                                                    <th style={{ textAlign: "center" }}>
                                                        { yetkiEkle === true ? <button className="btn btn-sm btn-icon text-success" onClick={() => EkleKarekodGrubu()}><i className="bi bi-plus-circle"></i></button> : ''}
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th style={{ textAlign: "center", minWidth: "64px", paddingLeft:"1.9rem" }}>
                                                        <input type="checkbox" checked={checkAll} onChange={handleCheckAll} className="form-check-input"></input>
                                                    </th>
                                                    <th style={{ textAlign: "center" }}><input name="karekodGrubuKriter" type="text" className="form-control form-control-xsm" value={karekodGrubuKriter} onChange={(e) => setKarekodGrubuKriter(e.target.value)} ></input></th>
                                                    <th style={{ textAlign: "center" }}>
                                                        <select className="form-select form-select-sm" value={urunGrubuIdKriter} onChange={(e) => setUrunGrubuIdKriter(e.target.value)}>
                                                            <option value="0"></option>
                                                            {
                                                                dataUrunGrubu && dataUrunGrubu.length > 0 ?
                                                                dataUrunGrubu.map((item, index) => {
                                                                    return (
                                                                        <option key={index} value={item.id}>{item.ad}</option>
                                                                    )
                                                                })
                                                                :
                                                                null
                                                            }
                                                        </select>
                                                    </th>
                                                    <th style={{ textAlign: "center" }}>
                                                        <select className="form-select form-select-sm" value={urunOlcusuIdKriter} onChange={(e) => setUrunOlcusuIdKriter(e.target.value)}>
                                                            <option value="0"></option>
                                                            {
                                                                dataUrunOlcusu && dataUrunOlcusu.length > 0 ?
                                                                dataUrunOlcusu.map((item, index) => {
                                                                    return (
                                                                        <option key={index} value={item.id}>{item.ad}</option>
                                                                    )
                                                                })
                                                                :
                                                                null
                                                            }
                                                        </select>
                                                    </th>
                                                    <th style={{ textAlign: "center" }}><input name="gtinKriter" type="text" className="form-control form-control-xsm" value={gtinKriter} onChange={(e) => setGtinKriter(e.target.value)} ></input></th>
                                                    <th style={{ textAlign: "center" }}><input name="refNoKriter" type="text" className="form-control form-control-xsm" value={refNoKriter} onChange={(e) => setRefNoKriter(e.target.value)} ></input></th>
                                                    <th style={{ textAlign: "center" }}><input name="miktarKriter" type="text" className="form-control form-control-xsm" value={miktarKriter} onChange={(e) => setMiktarKriter(e.target.value)} ></input></th>
                                                    <th style={{ textAlign: "center" }}><input name="karekodSayisiKriter" type="text" className="form-control form-control-xsm" value={karekodSayisiKriter} onChange={(e) => setKarekodSayisiKriter(e.target.value)} ></input></th>
                                                    <th style={{ textAlign: "center" }}><input name="karekodUretilenSayisiKriter" type="text" className="form-control form-control-xsm" value={karekodUretilenSayisiKriter} onChange={(e) => setKarekodUretilenSayisiKriter(e.target.value)} ></input></th>
                                                    <th style={{ textAlign: "center" }}><DatePicker className="form-control form-control-xsm text-center" calendarStartDay={0} todayButton="Bugün" dateFormat="dd.MM.yyyy" locale={datePickerLocale} selectsRange={true} isClearable={false} startDate={olusturulmaZamani1Kriter} endDate={olusturulmaZamani2Kriter} onChange={(update) => { handleOlusturulmaZamaniKriterChange(update); }} /></th>
                                                    <th style={{ textAlign: "center" }}><button className="btn btn-sm btn-icon text-success" type='submit' onClick={() => Sorgula()}><i className="bi bi-search"></i></button></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    data && data.length > 0 ?
                                                        data.map((itemKarekodGrubu, indexKarekodGrubu) => {
                                                            return (
                                                                <React.Fragment>
                                                                    <tr key={"KarekodGrubu" + indexKarekodGrubu}>
                                                                        <td align="center">
                                                                            <label htmlFor={"cbExpandedKarekodGrubu" + itemKarekodGrubu.id} style={{cursor:"pointer"}}>
                                                                                <i className={itemKarekodGrubu.expanded === true ? "bi bi-chevron-down" : "bi bi-chevron-right"}></i>
                                                                            </label>
                                                                            <input id={"cbExpandedKarekodGrubu" + itemKarekodGrubu.id} type="checkbox" className="form-check-input" style={{visibility:'hidden'}} checked={itemKarekodGrubu.expanded} onChange={() => handleExpandedKarekodGrubu(indexKarekodGrubu, !itemKarekodGrubu.expanded)}></input>
                                                                            <input type="checkbox" className="form-check-input" checked={itemKarekodGrubu.checked} onChange={() => handleCheck(indexKarekodGrubu, !itemKarekodGrubu.checked)}></input>
                                                                        </td>
                                                                        <td align="center">{itemKarekodGrubu.karekodGrubu}</td>
                                                                        <td align="center">{itemKarekodGrubu.urunGrubu}</td>
                                                                        <td align="center">{itemKarekodGrubu.urunOlcusu}</td>
                                                                        <td align="center">{itemKarekodGrubu.gtin}</td>
                                                                        <td align="center">{itemKarekodGrubu.refNo}</td>
                                                                        <td align="center">{itemKarekodGrubu.miktar}</td>
                                                                        <td align="center">{itemKarekodGrubu.karekodSayisi}</td>
                                                                        <td align="center">{itemKarekodGrubu.karekodUretilenSayisi}</td>
                                                                        <td align="center">{itemKarekodGrubu.olusturulmaZamani === null ? "" : moment(itemKarekodGrubu.olusturulmaZamani).format('DD.MM.YYYY HH:mm')}</td>
                                                                        <td align="center">
                                                                            <div className='btn-group'>
                                                                                { yetkiDegistir === true ? <button className="btn btn-sm btn-icon text-info" onClick={() => DegistirKarekodGrubu(itemKarekodGrubu.id)}><i className="bi bi-pencil"></i></button> : ''}
                                                                                { yetkiSil === true ? <button className="btn btn-sm btn-icon text-danger" onClick={() => SilKarekodGrubu(itemKarekodGrubu.id)}><i className="bi bi-trash"></i></button> : ''}
                                                                                <button id={"btnYenileKarekodGrubu" + itemKarekodGrubu.id} onClick={() => YenileKarekodGrubu(itemKarekodGrubu.id, indexKarekodGrubu)} style={{visibility:"hidden"}}></button>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    {
                                                                        itemKarekodGrubu.expanded === true ?
                                                                            <tr key={"KarekodGrubuExpand" + indexKarekodGrubu}>
                                                                                <td colSpan="12" style={{padding:"1rem"}}>
                                                                                    <GridKarekod karekodFilterDTO={itemKarekodGrubu.karekodFilterDTO} miktar={itemKarekodGrubu.miktar}></GridKarekod>
                                                                                </td>
                                                                            </tr>
                                                                            :
                                                                            ""
                                                                    }
                                                                </React.Fragment>
                                                            )
                                                        })
                                                        :
                                                        <tr>
                                                            <td align="center" colSpan="12">
                                                                Kayıt bulunamadı
                                                            </td>
                                                        </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="row" style={{ placeItems: "center", padding: "8px" }}>
                                        <div className="col-md-4" style={{ display: "ruby" }}>
                                            <span className="badge bg-primary">{rowCount + " kayıt"}</span>
                                        </div>
                                        <div className="col-md-4" style={{ textAlign: "-webkit-center" }}>
                                            <div style={{ display: "flex", width: "224px" }}>
                                                <button className="btn btn-sm btn-icon text-info" onClick={async () => NavIlk()}><i className="bi bi-caret-left-fill"></i></button>
                                                <button className="btn btn-sm btn-icon text-info" onClick={async () => NavGeri()}><i className="bi bi-caret-left"></i></button>
                                                <div className="input-group">
                                                    <input type="text" className="form-control form-control-xsm text-center" value={pageNo} onChange={(e) => handlePageNo(e.target.value)}></input>
                                                    <div className="form-control form-control-xsm text-center" style={{ borderLeft: "none" }}>{" / " + lastPage}</div>
                                                </div>
                                                <button className="btn btn-sm btn-icon text-info" onClick={async () => NavIleri()}><i className="bi bi-caret-right"></i></button>
                                                <button className="btn btn-sm btn-icon text-info" onClick={async () => NavSon()}><i className="bi bi-caret-right-fill"></i></button>
                                            </div>
                                        </div>
                                        <div className="col-md-4" style={{ textAlign: "-webkit-right" }}>
                                            <select className="form-select form-select-xsm" style={{ width: "128px" }} value={pageSize} onChange={async (e) => handlePageSize(e.target.value)}>
                                                <option value="5">5 kayıt göster</option>
                                                <option value="10">10 kayıt göster</option>
                                                <option value="25">25 kayıt göster</option>
                                                <option value="50">50 kayıt göster</option>
                                                <option value="100">100 kayıt göster</option>
                                                <option value="250">250 kayıt göster</option>
                                                <option value="500">500 kayıt göster</option>
                                                <option value="1000">1000 kayıt göster</option>
                                                <option value="5000">5000 kayıt göster</option>
                                                <option value="10000">10000 kayıt göster</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <button className="btn btn-link btn-sm" style={{marginRight:"1rem"}} onClick={() => ExportMatbaa(0, 1)}>Gizli Sekmeler Açık Matbaa Dosyası Hazırla</button>
                                <button className="btn btn-link btn-sm" style={{marginRight:"1rem"}} onClick={() => ExportMatbaa(0, 0)}>Gizli Sekmeler Kapalı Matbaa Dosyası Hazırla</button>
                                <button className="btn btn-link btn-sm" style={{marginRight:"1rem"}} onClick={() => ExportKutu(0)}>Box Dosyası Hazırla</button>
                                <button className="btn btn-link btn-sm" style={{marginRight:"1rem"}} onClick={() => Import("SterilNo")}>Steril Numaralarını Aktar</button>
                                <button className="btn btn-link btn-sm" onClick={() => Import("KutuNo")}>Box Numaralarını Aktar</button>

                            </div>
                        :
                        ""
            }

            <Modal show={showKarekodGrubu} onHide={handleCloseKarekodGrubu} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Ürün Çeşidi Kaydı</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className="col-md-12 mb-3">
                            <div className="input-group input-group-sm">
                                <label className="input-group-text" id="lblKarekodGrubu" style={{ width: "120px" }}>Proje No<span style={{ color: "red", paddingLeft: "4px" }}>*</span></label>
                                <input aria-describedby="lblKarekodGrubu" type="text" className="form-control form-control-sm" value={karekodGrubuData} onChange={(e) => setKarekodGrubuData(e.target.value)}></input>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="input-group input-group-sm">
                                <label className="input-group-text" id="lblUrunGrubuUrunOlcusuData" style={{width:"120px"}}>Ürün Çeşidi<span style={{color:"red", paddingLeft:"4px"}}>*</span></label>
                                <select className="form-select form-select-sm" value={urunGrubuUrunOlcusuIdData} onChange={(e) => setUrunGrubuUrunOlcusuIdData(e.target.value)} disabled={karekodGrubuIdData !== 0}>
                                    <option value="0"></option>
                                    {
                                        dataUrunGrubuUrunOlcusu && dataUrunGrubuUrunOlcusu.length > 0 ?
                                        dataUrunGrubuUrunOlcusu.map((item, index) => {
                                            return (
                                                <option key={index} value={item.id}>{item.ad}</option>
                                            )
                                        })
                                        :
                                        null
                                    }
                                </select>
                            </div>
                        </div>
                    </div>     
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-success" onClick={() => KaydetKarekodGrubu()}><i className="bi bi-check-lg mr-2"></i> Kaydet</button>
                    <button className="btn btn-secondary" onClick={handleCloseKarekodGrubu}><i className="bi bi-x"></i> Vazgeç</button>
                </Modal.Footer>
            </Modal>

            <Modal show={showImport} onHide={handleCloseImport} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{importTipi === "KutuNo" ? "Box No Import" : (importTipi === "SterilNo" ? "Steril No Import" : "")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className="input-group input-group-sm">
                                <textarea rows="20" className="form-control form-control-sm" value={importVeriData} onChange={(e) => setImportVeriData(e.target.value)} 
                                    placeholder={"Excelden kopyalayacağınız" + (importTipi === "KutuNo" ? " üretilen karekod ve box " : (importTipi === "SterilNo" ? " okutulan karekod ve steril no " : "")) + "sütunlarından oluşan veri bölümünü buraya yapıştırınız"}></textarea>
                            </div>
                        </div>
                    </div>     
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-success" onClick={() => KaydetImport()}><i className="bi bi-check-lg mr-2"></i> Aktarımı Başlat</button>
                    <button className="btn btn-secondary" onClick={handleCloseImport}><i className="bi bi-x"></i> Vazgeç</button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default Karekod;